// @generated by Peggy 4.1.1.
//
// https://peggyjs.org/

function extractList (list, index) {
  return list.map(function (element) {
    return element[index]
  })
}

function buildList (head, tail, index) {
  return [head].concat(extractList(tail, index))
}

function cleanup (obj) {
  // console.log(`obj:${JSON.stringify(obj)}`)
  return Array.isArray(obj) ? obj.filter(k => k) : []
}

function peg$subclass (child, parent) {
  function C () {
    this.constructor = child
  }
  C.prototype = parent.prototype
  child.prototype = new C()
}

function peg$SyntaxError (message, expected, found, location) {
  var self = Error.call(this, message)
  // istanbul ignore next Check is a necessary evil to support older environments
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(self, peg$SyntaxError.prototype)
  }
  self.expected = expected
  self.found = found
  self.location = location
  self.name = 'SyntaxError'
  return self
}

peg$subclass(peg$SyntaxError, Error)

function peg$padEnd (str, targetLength, padString) {
  padString = padString || ' '
  if (str.length > targetLength) {
    return str
  }
  targetLength -= str.length
  padString += padString.repeat(targetLength)
  return str + padString.slice(0, targetLength)
}

peg$SyntaxError.prototype.format = function (sources) {
  var str = 'Error: ' + this.message
  if (this.location) {
    var src = null
    var k
    for (k = 0; k < sources.length; k++) {
      if (sources[k].source === this.location.source) {
        src = sources[k].text.split(/\r\n|\n|\r/g)
        break
      }
    }
    var s = this.location.start
    var offset_s =
      this.location.source && typeof this.location.source.offset === 'function'
        ? this.location.source.offset(s)
        : s
    var loc = this.location.source + ':' + offset_s.line + ':' + offset_s.column
    if (src) {
      var e = this.location.end
      var filler = peg$padEnd('', offset_s.line.toString().length, ' ')
      var line = src[s.line - 1]
      var last = s.line === e.line ? e.column : line.length + 1
      var hatLen = last - s.column || 1
      str +=
        '\n --> ' +
        loc +
        '\n' +
        filler +
        ' |\n' +
        offset_s.line +
        ' | ' +
        line +
        '\n' +
        filler +
        ' | ' +
        peg$padEnd('', s.column - 1, ' ') +
        peg$padEnd('', hatLen, '^')
    } else {
      str += '\n at ' + loc
    }
  }
  return str
}

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function (expectation) {
      return '"' + literalEscape(expectation.text) + '"'
    },

    class: function (expectation) {
      var escapedParts = expectation.parts.map(function (part) {
        return Array.isArray(part)
          ? classEscape(part[0]) + '-' + classEscape(part[1])
          : classEscape(part)
      })

      return (
        '[' + (expectation.inverted ? '^' : '') + escapedParts.join('') + ']'
      )
    },

    any: function () {
      return 'any character'
    },

    end: function () {
      return 'end of input'
    },

    other: function (expectation) {
      return expectation.description
    }
  }

  function hex (ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase()
  }

  function literalEscape (s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch)
      })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch)
      })
  }

  function classEscape (s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g, '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch)
      })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch)
      })
  }

  function describeExpectation (expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation)
  }

  function describeExpected (expected) {
    var descriptions = expected.map(describeExpectation)
    var i, j

    descriptions.sort()

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i]
          j++
        }
      }
      descriptions.length = j
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0]

      case 2:
        return descriptions[0] + ' or ' + descriptions[1]

      default:
        return (
          descriptions.slice(0, -1).join(', ') +
          ', or ' +
          descriptions[descriptions.length - 1]
        )
    }
  }

  function describeFound (found) {
    return found ? '"' + literalEscape(found) + '"' : 'end of input'
  }

  return (
    'Expected ' +
    describeExpected(expected) +
    ' but ' +
    describeFound(found) +
    ' found.'
  )
}

function peg$parse (input, options) {
  options = options !== undefined ? options : {}

  var peg$FAILED = {}
  var peg$source = options.grammarSource

  var peg$startRuleFunctions = { Start: peg$parseStart }
  var peg$startRuleFunction = peg$parseStart

  var peg$c0 = 'robot'
  var peg$c1 = 'addMoveCommand'
  var peg$c2 = 'addTurnCommand'
  var peg$c3 = 'addPickupCommand'
  var peg$c4 = 'addDropCommand'
  var peg$c5 = 'addShootCommand'
  var peg$c6 = '.'
  var peg$c7 = '0'
  var peg$c8 = '"'
  var peg$c9 = '/*'
  var peg$c10 = '*/'
  var peg$c11 = '//'
  var peg$c12 = '\n'
  var peg$c13 = '\r\n'
  var peg$c14 = ';'
  var peg$c15 = ','
  var peg$c16 = '('
  var peg$c17 = ')'

  var peg$r0 = /^[0-9]/
  var peg$r1 = /^[1-9]/
  var peg$r2 = /^[\n\r"\u2028-\u2029]/
  var peg$r3 = /^[\t\v-\f \xA0\u1680\u2000-\u200A\u202F\u205F\u3000\uFEFF]/
  var peg$r4 = /^[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/
  var peg$r5 = /^[\n\r\u2028\u2029]/
  var peg$r6 = /^[\r\u2028-\u2029]/

  var peg$e0 = peg$anyExpectation()
  var peg$e1 = peg$literalExpectation('robot', false)
  var peg$e2 = peg$literalExpectation('addMoveCommand', false)
  var peg$e3 = peg$literalExpectation('addTurnCommand', false)
  var peg$e4 = peg$literalExpectation('addPickupCommand', false)
  var peg$e5 = peg$literalExpectation('addDropCommand', false)
  var peg$e6 = peg$literalExpectation('addShootCommand', false)
  var peg$e7 = peg$literalExpectation('.', false)
  var peg$e8 = peg$literalExpectation('0', false)
  var peg$e9 = peg$classExpectation([['0', '9']], false, false)
  var peg$e10 = peg$classExpectation([['1', '9']], false, false)
  var peg$e11 = peg$otherExpectation('string')
  var peg$e12 = peg$literalExpectation('"', false)
  var peg$e13 = peg$classExpectation(
    ['\n', '\r', '"', ['\u2028', '\u2029']],
    false,
    false
  )
  var peg$e14 = peg$otherExpectation('comment')
  var peg$e15 = peg$literalExpectation('/*', false)
  var peg$e16 = peg$literalExpectation('*/', false)
  var peg$e17 = peg$literalExpectation('//', false)
  var peg$e18 = peg$otherExpectation('whitespace')
  var peg$e19 = peg$classExpectation(
    [
      '\t',
      ['\v', '\f'],
      ' ',
      '\xA0',
      '\u1680',
      ['\u2000', '\u200A'],
      '\u202F',
      '\u205F',
      '\u3000',
      '\uFEFF'
    ],
    false,
    false
  )
  var peg$e20 = peg$classExpectation(
    [' ', '\xA0', '\u1680', ['\u2000', '\u200A'], '\u202F', '\u205F', '\u3000'],
    false,
    false
  )
  var peg$e21 = peg$classExpectation(
    ['\n', '\r', '\u2028', '\u2029'],
    false,
    false
  )
  var peg$e22 = peg$otherExpectation('end of line')
  var peg$e23 = peg$literalExpectation('\n', false)
  var peg$e24 = peg$literalExpectation('\r\n', false)
  var peg$e25 = peg$classExpectation(['\r', ['\u2028', '\u2029']], false, false)
  var peg$e26 = peg$literalExpectation(';', false)
  var peg$e27 = peg$literalExpectation(',', false)
  var peg$e28 = peg$literalExpectation('(', false)
  var peg$e29 = peg$literalExpectation(')', false)

  var peg$f0 = function (program) {
    return cleanup(program)
  }
  var peg$f1 = function (obj, cmd, args) {
    // console.log({ obj, cmd, args })
    return { obj, cmd, args, loc: location() }
  }
  var peg$f2 = function () {
    return null
  }
  var peg$f3 = function () {
    return null
  }
  var peg$f4 = function (head, tail) {
    return buildList(head, tail, 3)
  }
  var peg$f5 = function () {
    return { type: 'Number', value: parseFloat(text()) }
  }
  var peg$f6 = function () {
    return { type: 'Number', value: parseFloat(text()) }
  }
  var peg$f7 = function (chars) {
    return { type: 'String', value: chars.join('') }
  }
  var peg$f8 = function () {
    return text()
  }
  var peg$currPos = options.peg$currPos | 0
  var peg$savedPos = peg$currPos
  var peg$posDetailsCache = [{ line: 1, column: 1 }]
  var peg$maxFailPos = peg$currPos
  var peg$maxFailExpected = options.peg$maxFailExpected || []
  var peg$silentFails = options.peg$silentFails | 0

  var peg$result

  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error(
        'Can\'t start parsing from rule "' + options.startRule + '".'
      )
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule]
  }

  function text () {
    return input.substring(peg$savedPos, peg$currPos)
  }

  function offset () {
    return peg$savedPos
  }

  function range () {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos
    }
  }

  function location () {
    return peg$computeLocation(peg$savedPos, peg$currPos)
  }

  function expected (description, location) {
    location =
      location !== undefined
        ? location
        : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    )
  }

  function error (message, location) {
    location =
      location !== undefined
        ? location
        : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location)
  }

  function peg$literalExpectation (text, ignoreCase) {
    return { type: 'literal', text: text, ignoreCase: ignoreCase }
  }

  function peg$classExpectation (parts, inverted, ignoreCase) {
    return {
      type: 'class',
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    }
  }

  function peg$anyExpectation () {
    return { type: 'any' }
  }

  function peg$endExpectation () {
    return { type: 'end' }
  }

  function peg$otherExpectation (description) {
    return { type: 'other', description: description }
  }

  function peg$computePosDetails (pos) {
    var details = peg$posDetailsCache[pos]
    var p

    if (details) {
      return details
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1
      } else {
        p = pos
        while (!peg$posDetailsCache[--p]) {}
      }

      details = peg$posDetailsCache[p]
      details = {
        line: details.line,
        column: details.column
      }

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++
          details.column = 1
        } else {
          details.column++
        }

        p++
      }

      peg$posDetailsCache[pos] = details

      return details
    }
  }

  function peg$computeLocation (startPos, endPos, offset) {
    var startPosDetails = peg$computePosDetails(startPos)
    var endPosDetails = peg$computePosDetails(endPos)

    var res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    }
    if (offset && peg$source && typeof peg$source.offset === 'function') {
      res.start = peg$source.offset(res.start)
      res.end = peg$source.offset(res.end)
    }
    return res
  }

  function peg$fail (expected) {
    if (peg$currPos < peg$maxFailPos) {
      return
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos
      peg$maxFailExpected = []
    }

    peg$maxFailExpected.push(expected)
  }

  function peg$buildSimpleError (message, location) {
    return new peg$SyntaxError(message, null, null, location)
  }

  function peg$buildStructuredError (expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    )
  }

  function peg$parseStart () {
    var s0, s1, s2, s3

    s0 = peg$currPos
    s1 = peg$parse__()
    s2 = peg$parseProgram()
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__()
      peg$savedPos = s0
      s0 = peg$f0(s2)
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }

    return s0
  }

  function peg$parseProgram () {
    var s0, s1

    s0 = []
    s1 = peg$parseLine()
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1)
        s1 = peg$parseLine()
      }
    } else {
      s0 = peg$FAILED
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos
      peg$silentFails++
      if (input.length > peg$currPos) {
        s1 = input.charAt(peg$currPos)
        peg$currPos++
      } else {
        s1 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e0)
        }
      }
      peg$silentFails--
      if (s1 === peg$FAILED) {
        s0 = undefined
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    }

    return s0
  }

  function peg$parseLine () {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15

    s0 = peg$currPos
    s1 = peg$parse__()
    s2 = peg$parseObject()
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__()
      s4 = peg$parseDOT()
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__()
        s6 = peg$parseCommand()
        if (s6 !== peg$FAILED) {
          s7 = peg$parse__()
          s8 = peg$parseLPAREN()
          if (s8 !== peg$FAILED) {
            s9 = peg$parse__()
            s10 = peg$parseArglist()
            if (s10 !== peg$FAILED) {
              s11 = peg$parse__()
              s12 = peg$parseRPAREN()
              if (s12 !== peg$FAILED) {
                s13 = peg$parse__()
                s14 = peg$parseSEMI()
                if (s14 !== peg$FAILED) {
                  s15 = peg$parse__()
                  peg$savedPos = s0
                  s0 = peg$f1(s2, s6, s10)
                } else {
                  peg$currPos = s0
                  s0 = peg$FAILED
                }
              } else {
                peg$currPos = s0
                s0 = peg$FAILED
              }
            } else {
              peg$currPos = s0
              s0 = peg$FAILED
            }
          } else {
            peg$currPos = s0
            s0 = peg$FAILED
          }
        } else {
          peg$currPos = s0
          s0 = peg$FAILED
        }
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos
      s1 = peg$parse__()
      s2 = peg$parseSingleLineComment()
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__()
        peg$savedPos = s0
        s0 = peg$f2()
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos
        s1 = peg$parse__()
        s2 = peg$parseMultiLineComment()
        if (s2 !== peg$FAILED) {
          s3 = peg$parse__()
          peg$savedPos = s0
          s0 = peg$f3()
        } else {
          peg$currPos = s0
          s0 = peg$FAILED
        }
      }
    }

    return s0
  }

  function peg$parseObject () {
    var s0

    if (input.substr(peg$currPos, 5) === peg$c0) {
      s0 = peg$c0
      peg$currPos += 5
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e1)
      }
    }

    return s0
  }

  function peg$parseCommand () {
    var s0

    s0 = peg$parsemoveCommand()
    if (s0 === peg$FAILED) {
      s0 = peg$parseturnCommand()
      if (s0 === peg$FAILED) {
        s0 = peg$parsepickupCommand()
        if (s0 === peg$FAILED) {
          s0 = peg$parsedropCommand()
          if (s0 === peg$FAILED) {
            s0 = peg$parseshootCommand()
          }
        }
      }
    }

    return s0
  }

  function peg$parsemoveCommand () {
    var s0

    if (input.substr(peg$currPos, 14) === peg$c1) {
      s0 = peg$c1
      peg$currPos += 14
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e2)
      }
    }

    return s0
  }

  function peg$parseturnCommand () {
    var s0

    if (input.substr(peg$currPos, 14) === peg$c2) {
      s0 = peg$c2
      peg$currPos += 14
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e3)
      }
    }

    return s0
  }

  function peg$parsepickupCommand () {
    var s0

    if (input.substr(peg$currPos, 16) === peg$c3) {
      s0 = peg$c3
      peg$currPos += 16
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e4)
      }
    }

    return s0
  }

  function peg$parsedropCommand () {
    var s0

    if (input.substr(peg$currPos, 14) === peg$c4) {
      s0 = peg$c4
      peg$currPos += 14
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e5)
      }
    }

    return s0
  }

  function peg$parseshootCommand () {
    var s0

    if (input.substr(peg$currPos, 15) === peg$c5) {
      s0 = peg$c5
      peg$currPos += 15
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e6)
      }
    }

    return s0
  }

  function peg$parseArglist () {
    var s0, s1, s2, s3, s4, s5, s6, s7

    s0 = peg$currPos
    s1 = peg$parseArg()
    if (s1 !== peg$FAILED) {
      s2 = []
      s3 = peg$currPos
      s4 = peg$parse_()
      s5 = peg$parseCOMMA()
      if (s5 !== peg$FAILED) {
        s6 = peg$parse_()
        s7 = peg$parseArg()
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7]
          s3 = s4
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      } else {
        peg$currPos = s3
        s3 = peg$FAILED
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3)
        s3 = peg$currPos
        s4 = peg$parse_()
        s5 = peg$parseCOMMA()
        if (s5 !== peg$FAILED) {
          s6 = peg$parse_()
          s7 = peg$parseArg()
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7]
            s3 = s4
          } else {
            peg$currPos = s3
            s3 = peg$FAILED
          }
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      }
      peg$savedPos = s0
      s0 = peg$f4(s1, s2)
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parse_()
    }

    return s0
  }

  function peg$parseArg () {
    var s0

    s0 = peg$parseDecimalLiteral()
    if (s0 === peg$FAILED) {
      s0 = peg$parseStringLiteral()
    }

    return s0
  }

  function peg$parseSourceCharacter () {
    var s0

    if (input.length > peg$currPos) {
      s0 = input.charAt(peg$currPos)
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e0)
      }
    }

    return s0
  }

  function peg$parseDecimalLiteral () {
    var s0, s1, s2, s3, s4

    s0 = peg$currPos
    s1 = peg$parseDecimalIntegerLiteral()
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s2 = peg$c6
        peg$currPos++
      } else {
        s2 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e7)
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = []
        s4 = peg$parseDecimalDigit()
        while (s4 !== peg$FAILED) {
          s3.push(s4)
          s4 = peg$parseDecimalDigit()
        }
        peg$savedPos = s0
        s0 = peg$f5()
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos
      s1 = peg$parseDecimalIntegerLiteral()
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0
        s1 = peg$f6()
      }
      s0 = s1
    }

    return s0
  }

  function peg$parseDecimalIntegerLiteral () {
    var s0, s1, s2, s3

    if (input.charCodeAt(peg$currPos) === 48) {
      s0 = peg$c7
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e8)
      }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos
      s1 = peg$parseNonZeroDigit()
      if (s1 !== peg$FAILED) {
        s2 = []
        s3 = peg$parseDecimalDigit()
        while (s3 !== peg$FAILED) {
          s2.push(s3)
          s3 = peg$parseDecimalDigit()
        }
        s1 = [s1, s2]
        s0 = s1
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    }

    return s0
  }

  function peg$parseDecimalDigit () {
    var s0

    s0 = input.charAt(peg$currPos)
    if (peg$r0.test(s0)) {
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e9)
      }
    }

    return s0
  }

  function peg$parseNonZeroDigit () {
    var s0

    s0 = input.charAt(peg$currPos)
    if (peg$r1.test(s0)) {
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e10)
      }
    }

    return s0
  }

  function peg$parseStringLiteral () {
    var s0, s1, s2, s3

    peg$silentFails++
    s0 = peg$currPos
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c8
      peg$currPos++
    } else {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e12)
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = []
      s3 = peg$parseDoubleStringCharacter()
      while (s3 !== peg$FAILED) {
        s2.push(s3)
        s3 = peg$parseDoubleStringCharacter()
      }
      if (input.charCodeAt(peg$currPos) === 34) {
        s3 = peg$c8
        peg$currPos++
      } else {
        s3 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e12)
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0
        s0 = peg$f7(s2)
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }
    peg$silentFails--
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e11)
      }
    }

    return s0
  }

  function peg$parseDoubleStringCharacter () {
    var s0, s1, s2

    s0 = peg$currPos
    s1 = peg$currPos
    peg$silentFails++
    s2 = input.charAt(peg$currPos)
    if (peg$r2.test(s2)) {
      peg$currPos++
    } else {
      s2 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e13)
      }
    }
    peg$silentFails--
    if (s2 === peg$FAILED) {
      s1 = undefined
    } else {
      peg$currPos = s1
      s1 = peg$FAILED
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseSourceCharacter()
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0
        s0 = peg$f8()
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }

    return s0
  }

  function peg$parseComment () {
    var s0, s1

    peg$silentFails++
    s0 = peg$parseMultiLineComment()
    if (s0 === peg$FAILED) {
      s0 = peg$parseSingleLineComment()
    }
    peg$silentFails--
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e14)
      }
    }

    return s0
  }

  function peg$parseMultiLineComment () {
    var s0, s1, s2, s3, s4, s5

    s0 = peg$currPos
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9
      peg$currPos += 2
    } else {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e15)
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = []
      s3 = peg$currPos
      s4 = peg$currPos
      peg$silentFails++
      if (input.substr(peg$currPos, 2) === peg$c10) {
        s5 = peg$c10
        peg$currPos += 2
      } else {
        s5 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e16)
        }
      }
      peg$silentFails--
      if (s5 === peg$FAILED) {
        s4 = undefined
      } else {
        peg$currPos = s4
        s4 = peg$FAILED
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseSourceCharacter()
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5]
          s3 = s4
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      } else {
        peg$currPos = s3
        s3 = peg$FAILED
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3)
        s3 = peg$currPos
        s4 = peg$currPos
        peg$silentFails++
        if (input.substr(peg$currPos, 2) === peg$c10) {
          s5 = peg$c10
          peg$currPos += 2
        } else {
          s5 = peg$FAILED
          if (peg$silentFails === 0) {
            peg$fail(peg$e16)
          }
        }
        peg$silentFails--
        if (s5 === peg$FAILED) {
          s4 = undefined
        } else {
          peg$currPos = s4
          s4 = peg$FAILED
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseSourceCharacter()
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5]
            s3 = s4
          } else {
            peg$currPos = s3
            s3 = peg$FAILED
          }
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      }
      if (input.substr(peg$currPos, 2) === peg$c10) {
        s3 = peg$c10
        peg$currPos += 2
      } else {
        s3 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e16)
        }
      }
      if (s3 !== peg$FAILED) {
        s1 = [s1, s2, s3]
        s0 = s1
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }

    return s0
  }

  function peg$parseMultiLineCommentNoLineTerminator () {
    var s0, s1, s2, s3, s4, s5

    s0 = peg$currPos
    if (input.substr(peg$currPos, 2) === peg$c9) {
      s1 = peg$c9
      peg$currPos += 2
    } else {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e15)
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = []
      s3 = peg$currPos
      s4 = peg$currPos
      peg$silentFails++
      if (input.substr(peg$currPos, 2) === peg$c10) {
        s5 = peg$c10
        peg$currPos += 2
      } else {
        s5 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e16)
        }
      }
      if (s5 === peg$FAILED) {
        s5 = peg$parseLineTerminator()
      }
      peg$silentFails--
      if (s5 === peg$FAILED) {
        s4 = undefined
      } else {
        peg$currPos = s4
        s4 = peg$FAILED
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseSourceCharacter()
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5]
          s3 = s4
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      } else {
        peg$currPos = s3
        s3 = peg$FAILED
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3)
        s3 = peg$currPos
        s4 = peg$currPos
        peg$silentFails++
        if (input.substr(peg$currPos, 2) === peg$c10) {
          s5 = peg$c10
          peg$currPos += 2
        } else {
          s5 = peg$FAILED
          if (peg$silentFails === 0) {
            peg$fail(peg$e16)
          }
        }
        if (s5 === peg$FAILED) {
          s5 = peg$parseLineTerminator()
        }
        peg$silentFails--
        if (s5 === peg$FAILED) {
          s4 = undefined
        } else {
          peg$currPos = s4
          s4 = peg$FAILED
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseSourceCharacter()
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5]
            s3 = s4
          } else {
            peg$currPos = s3
            s3 = peg$FAILED
          }
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      }
      if (input.substr(peg$currPos, 2) === peg$c10) {
        s3 = peg$c10
        peg$currPos += 2
      } else {
        s3 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e16)
        }
      }
      if (s3 !== peg$FAILED) {
        s1 = [s1, s2, s3]
        s0 = s1
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }

    return s0
  }

  function peg$parseSingleLineComment () {
    var s0, s1, s2, s3, s4, s5

    s0 = peg$currPos
    if (input.substr(peg$currPos, 2) === peg$c11) {
      s1 = peg$c11
      peg$currPos += 2
    } else {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e17)
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = []
      s3 = peg$currPos
      s4 = peg$currPos
      peg$silentFails++
      s5 = peg$parseLineTerminator()
      peg$silentFails--
      if (s5 === peg$FAILED) {
        s4 = undefined
      } else {
        peg$currPos = s4
        s4 = peg$FAILED
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseSourceCharacter()
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5]
          s3 = s4
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      } else {
        peg$currPos = s3
        s3 = peg$FAILED
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3)
        s3 = peg$currPos
        s4 = peg$currPos
        peg$silentFails++
        s5 = peg$parseLineTerminator()
        peg$silentFails--
        if (s5 === peg$FAILED) {
          s4 = undefined
        } else {
          peg$currPos = s4
          s4 = peg$FAILED
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseSourceCharacter()
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5]
            s3 = s4
          } else {
            peg$currPos = s3
            s3 = peg$FAILED
          }
        } else {
          peg$currPos = s3
          s3 = peg$FAILED
        }
      }
      s1 = [s1, s2]
      s0 = s1
    } else {
      peg$currPos = s0
      s0 = peg$FAILED
    }

    return s0
  }

  function peg$parseWhiteSpace () {
    var s0, s1

    peg$silentFails++
    s0 = input.charAt(peg$currPos)
    if (peg$r3.test(s0)) {
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e19)
      }
    }
    peg$silentFails--
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e18)
      }
    }

    return s0
  }

  function peg$parse__ () {
    var s0, s1

    s0 = []
    s1 = peg$parseWhiteSpace()
    if (s1 === peg$FAILED) {
      s1 = peg$parseLineTerminatorSequence()
      if (s1 === peg$FAILED) {
        s1 = peg$parseComment()
      }
    }
    while (s1 !== peg$FAILED) {
      s0.push(s1)
      s1 = peg$parseWhiteSpace()
      if (s1 === peg$FAILED) {
        s1 = peg$parseLineTerminatorSequence()
        if (s1 === peg$FAILED) {
          s1 = peg$parseComment()
        }
      }
    }

    return s0
  }

  function peg$parse_ () {
    var s0, s1

    s0 = []
    s1 = peg$parseWhiteSpace()
    if (s1 === peg$FAILED) {
      s1 = peg$parseMultiLineCommentNoLineTerminator()
    }
    while (s1 !== peg$FAILED) {
      s0.push(s1)
      s1 = peg$parseWhiteSpace()
      if (s1 === peg$FAILED) {
        s1 = peg$parseMultiLineCommentNoLineTerminator()
      }
    }

    return s0
  }

  function peg$parseZs () {
    var s0

    s0 = input.charAt(peg$currPos)
    if (peg$r4.test(s0)) {
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e20)
      }
    }

    return s0
  }

  function peg$parseLineTerminator () {
    var s0

    s0 = input.charAt(peg$currPos)
    if (peg$r5.test(s0)) {
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e21)
      }
    }

    return s0
  }

  function peg$parseLineTerminatorSequence () {
    var s0, s1

    peg$silentFails++
    if (input.charCodeAt(peg$currPos) === 10) {
      s0 = peg$c12
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e23)
      }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c13) {
        s0 = peg$c13
        peg$currPos += 2
      } else {
        s0 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e24)
        }
      }
      if (s0 === peg$FAILED) {
        s0 = input.charAt(peg$currPos)
        if (peg$r6.test(s0)) {
          peg$currPos++
        } else {
          s0 = peg$FAILED
          if (peg$silentFails === 0) {
            peg$fail(peg$e25)
          }
        }
      }
    }
    peg$silentFails--
    if (s0 === peg$FAILED) {
      s1 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e22)
      }
    }

    return s0
  }

  function peg$parseEOL () {
    var s0, s1

    s0 = peg$parseLineTerminator()
    if (s0 === peg$FAILED) {
      s0 = peg$currPos
      peg$silentFails++
      if (input.length > peg$currPos) {
        s1 = input.charAt(peg$currPos)
        peg$currPos++
      } else {
        s1 = peg$FAILED
        if (peg$silentFails === 0) {
          peg$fail(peg$e0)
        }
      }
      peg$silentFails--
      if (s1 === peg$FAILED) {
        s0 = undefined
      } else {
        peg$currPos = s0
        s0 = peg$FAILED
      }
    }

    return s0
  }

  function peg$parseDOT () {
    var s0

    if (input.charCodeAt(peg$currPos) === 46) {
      s0 = peg$c6
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e7)
      }
    }

    return s0
  }

  function peg$parseSEMI () {
    var s0

    if (input.charCodeAt(peg$currPos) === 59) {
      s0 = peg$c14
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e26)
      }
    }

    return s0
  }

  function peg$parseCOMMA () {
    var s0

    if (input.charCodeAt(peg$currPos) === 44) {
      s0 = peg$c15
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e27)
      }
    }

    return s0
  }

  function peg$parseLPAREN () {
    var s0

    if (input.charCodeAt(peg$currPos) === 40) {
      s0 = peg$c16
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e28)
      }
    }

    return s0
  }

  function peg$parseRPAREN () {
    var s0

    if (input.charCodeAt(peg$currPos) === 41) {
      s0 = peg$c17
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e29)
      }
    }

    return s0
  }

  function peg$parseDQUOTE () {
    var s0

    if (input.charCodeAt(peg$currPos) === 34) {
      s0 = peg$c8
      peg$currPos++
    } else {
      s0 = peg$FAILED
      if (peg$silentFails === 0) {
        peg$fail(peg$e12)
      }
    }

    return s0
  }

  peg$result = peg$startRuleFunction()

  if (options.peg$library) {
    return /** @type {any} */ ({
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos
    })
  }
  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation())
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    )
  }
}

const peg$allowedStartRules = ['Start']

export {
  peg$allowedStartRules as StartRules,
  peg$SyntaxError as SyntaxError,
  peg$parse as parse
}
